import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.5 9V7M15 10L16.5 8.5M8 10L6.5 8.5M11.5 13.5V11M11.5 13.5C10.3954 13.5 9.5 14.3954 9.5 15.5M11.5 13.5C12.6046 13.5 13.5 14.3954 13.5 15.5M1.5 3.5H21.5V17L19 19.5H4L1.5 17V3.5ZM3.5 5.5V15.5H19.5V5.5H3.5Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }